import { useState, useEffect } from "react";
import XModal from "../../shared/XModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getPreferenceDataFromStorage } from "../../../helpers/utils";
import deleteIcon from "../../../static/images/deleteIcon.png";
import LostSales from "../../Checkout/LostSales";
import _head from 'lodash/head';
import _find from 'lodash/find';
import { submitLostSales, deleteItemFromCart2 } from "../../../actions/cart";

const LostSalesHandler = ({ order, cart, dispatch, userDetails, cartQuantity }) => {
  const [showLostSales, setshowLostSales] = useState(false);
  const [showLostSaleWarning, setShowLostSaleWarning] = useState(false);
  const [lostSaleData, setLostSaleData] = useState([]);
  const [isLostSalePreference, setIsLostSalePreference] = useState(false);

  useEffect(() => {
    let userPreferenceDetail = getPreferenceDataFromStorage();
    const lostSalePref = _find(userPreferenceDetail, { code: "Cart", text: "Lost Sales" });
    setIsLostSalePreference(lostSalePref?.answer?.code !== "implicit");
  }, []);

  const handleDeleteItem = (e, part) => {
    const itemToDelete = cart.checkoutDetails?.find(
      ({ partNum, orderType }) => partNum === part.partSKU && orderType === "STOCK_ORDER"
    );

    if (itemToDelete) {
      setLostSaleData([itemToDelete]);
    }
    // if (isLostSalePreference) {
    //   setshowLostSales(true)
    // } else {
      setShowLostSaleWarning(true);
    //}
  };


  const handleImplicitLostSaleSubmit = (lostSaleData) => {
    const modified = lostSaleData.map((item) => {
      return {
        availabilityDuration: item.availabilityHour,
        availableQty: item.availableQty,
        brandName: item.mfgCode,
        costPrice: item.costPrice,
        partDesc: item.desc,
        partNum: item.partNum,
        selectedQty: item.qty,
        userId: userDetails?.x2userName,
        userResponse: {
          availability: item.propAvailability,
          brand: item.propBrand,
          otherReason: ['Unknown'],
          customer: item.notInterested ? ['Not interested'] : undefined,
          betterPrice: item.betterPrice,
          fromWD: item.fromWD
        },
        vehicle: item.vehicleInfo
      };
    });
    submitLostSales(modified, dispatch);
    const deletePart = {
      availabilityHour: _head(lostSaleData).availabilityHour,
      partNum: _head(lostSaleData).partNum,
      qty: _head(lostSaleData).qty,
      vehicleInfo: _head(lostSaleData).vehicleInfo,
      mfgCode: _head(lostSaleData).mfgCode,
      pricingType: _head(lostSaleData).pricingType
    };
    setShowLostSaleWarning(false)
    deleteItemFromCart2(deletePart, dispatch, false);
  }


  const getDeleteIcon = (order) => (
    <OverlayTrigger
      placement="right"
      delay={{ show: 100, hide: 400 }}
      overlay={
        <Tooltip id="delete-tooltip" className="tooltip-description-custom-corePrice">
          <span className="font-weight-bold">Remove this item from the cart.</span>
        </Tooltip>
      }
    >
      <img
        src={deleteIcon}
        className="stock-delete-icon"
        onClick={(event) => handleDeleteItem(event, order)}
        alt="Delete"
      />
    </OverlayTrigger>
  );


  return (
    <>

      <span className="stock-is-incart">
        {cartQuantity}{" in Cart "} {getDeleteIcon(order)}
      </span>


      {showLostSales && (
        <LostSales
          isCart={true}
          openPopup={showLostSales}
          closePopup={() => setshowLostSales(false)}
          selectedPartDetails={lostSaleData}
          dispatch={dispatch}
          userId={userDetails.x2userName}
          source="deleteIcon"
        />
      )}

      {showLostSaleWarning && (
        <XModal
          show={showLostSaleWarning}
          handleClose={() => setShowLostSaleWarning(false)}
          handleAction={() => handleImplicitLostSaleSubmit(lostSaleData)}
          className="custom_xmodal"
          isValidValidity={true}
        >
          <div className="delete__text text__center">
            {"You want to delete this cart item"}
            <br />
          </div>
        </XModal>
      )}
    </>
  );
};

export default LostSalesHandler;
